import moment from "moment";
import React, { useEffect, useRef, useState, useCallback } from "react";
// import { Form, Modal } from "react-bootstrap";
import DatePicker from "react-datepicker";
// import { toast } from "react-hot-toast";
import { Link, useNavigate } from "react-router-dom";
import ReactSelect from "react-select";
import axios from "../../API/axios";
import { getUserConfig, getProfilePercentage } from "../../Services/apiService";
import { resume, userAuthImage } from "../../config/imagesLink";
import SuccessToast from "../SuccessToast";
import WarningToast from "../WarningToast";
import ErrorToast from "../ErrorToast";
import { Progress } from "reactstrap";
import Select from "react-select";
import Flatpickr from 'react-flatpickr';
import CheckSharpIcon from '@mui/icons-material/CheckSharp';
import CheckCircleOutlineSharpIcon from '@mui/icons-material/CheckCircleOutlineSharp';
import AddCircleSharpIcon from '@mui/icons-material/AddCircleSharp';
import CloseSharpIcon from '@mui/icons-material/CloseSharp';
import WarningAmberSharpIcon from '@mui/icons-material/WarningAmberSharp';
import EditSharpIcon from '@mui/icons-material/EditSharp';
import DeleteSharpIcon from '@mui/icons-material/DeleteSharp';
import RestoreIcon from '@mui/icons-material/Restore';
import DoDisturbOnOutlinedIcon from '@mui/icons-material/DoDisturbOnOutlined';
import CalendarMonthSharpIcon from '@mui/icons-material/CalendarMonthSharp';

import { useTranslation } from "react-i18next";
// import "./UpdateProfile.css";
import Cropper from "react-easy-crop";
import getCroppedImg from "./cropImage";
import ProfileBasicInfoModal from "./ProfileBasicInfoModal";
import { Portal } from "../../components/Portal";


const UpdateProfile = ({ getUserProfile, profileInfo }) => {
  const { t } = useTranslation();

  const sessionId = localStorage.getItem("sessionId");
  const userUid = localStorage.getItem("userUid");
  const ProfilePercent = localStorage.getItem("ProfilePercentage");

  const [toastMessage, setToastMessage] = useState("");
  const [showToast, setShowToast] = useState(false);

  const [warningToastMessage, setWarningToastMessage] = useState("");
  const [showWarningToast, setShowWarningToast] = useState(false);

  const [ErrorToastMessage, setErrorToastMessage] = useState("");
  const [showErrorToast, setShowErrorToast] = useState(false);
  const [userCcv, setUserCcv] = useState("");
  const language = localStorage.getItem("Lang");

  const [profileConfig, setProfileConfig] = useState([]);
  const [basicInfoModal, setBasicInfoModal] = useState(false);
  const [unauthorisedModal, setUnauthorisedModal] = useState(false);
  const [UserCcvid, setUserCcvid] = useState('');

  const userConfig = async ({ forceRefresh = false } = {}) => {
    try {
      const responseData = await getUserConfig({ forceRefresh });
      setProfileConfig(responseData);
    } catch (error) {
      if ((error.code === 'ERR_NETWORK' && sessionId) || (error.code === "ERR_BAD_REQUEST" && sessionId)) {
        setUnauthorisedModal(true)
      }
    }
  };
  const CheckUserCcv = async () => {
    const data = {
      deviceType: "Web",
      sessionId: sessionId,
      langKey: language === "en" ? "" : language,
    };
    try {
      await axios
        .post(`Resume/CheckUserResume`, data)
        .then((resData) => {
          // Handles no resume (204 No Content)
          if (resData.status === 204) {
            setUserCcv('NotFound');
            localStorage.setItem("UserCcv", 'NotFound');
            setUserCcvid('');
            return;
          }
          // Handles 'Active' (success)
          if (resData.data && resData.data.responseData && resData.data.responseData.value) {
            setUserCcv(resData.data.responseData.value);
            localStorage.setItem("UserCcv", resData.data.responseData.value);
            setUserCcvid(resData.data.responseData.id);
          } else {
            setUserCcv('NotFound');
          }
        });
    } catch (error) {
      // Handles 'Deactivated', 'Deleted', 'NotFound' (warning/error)
      let value = error.response?.data?.responseData?.value;
      if (error.response && error.response.status === 404) {
        // setWarningToastMessage(error.response.data.message);
        // setShowWarningToast(true);
        setUserCcv(error.response?.data?.responseData?.value || 'NotFound');
        localStorage.setItem("UserCcv", error.response?.data?.responseData?.value || 'NotFound');
        setUserCcvid(error.response?.data?.responseData?.id || '');

      } else {
        // setErrorToastMessage(error.response.data.message);
        // setShowErrorToast(true);
        setUserCcv(error.response?.data?.responseData?.value || 'NotFound');
        localStorage.setItem("UserCcv", error.response?.data?.responseData?.value || 'NotFound');
        setUserCcvid(error.response?.data?.responseData?.id || '');

      }
    }
  };

  const [createResumeMessage, setCreateResumeMessage] = useState('')
  console.log('userCcv', userCcv);

  const [showResumeModal, setShowResumeModal] = useState(false)
  const handleCloseManageResume = () => {
    setShowResumeModal(false)
  }

  const AddUserCcv = async () => {
    const data = {
      deviceType: "Web",
      sessionId: sessionId,
      langKey: language === "en" ? "" : language,
    };
    try {
      await axios.post(`Resume/AddUserResume`, data).then((resData) => {
        console.log('add user resData', resData);
        setCreateResumeMessage(resData?.message)
        setUserCcv(resData.data.responseData);
        getUserProfilePer({ forceRefresh: true });
        // getUserProfile()
        setShowResumeModal(true)
      });
    } catch (error) {
      if (error.response && error.response.status === 404) {
        setWarningToastMessage(error.response.data.message);
        setShowWarningToast(true);
      } else {
        setErrorToastMessage(error.response.data.message);
        setShowErrorToast(true);
      }
    }
  };
  useEffect(() => {
    userConfig();
    CheckUserCcv();
    // setShowResumeModal(true)
  }, []);
  const navigate = useNavigate();
  const redirectResume = () => {
    setShowResumeModal(false);
    navigate(`/ManageResume/${userUid}`);
  }
  //************************ Profile Picture   ************************//
  const [selectedprofileImage, setselectedprofileImage] = useState(null);

  const [profileImage, setprofileImage] = useState(null);
  const [profileCropImage, setProfileCropImage] = useState(null);
  const [profileSourceImage, setProfileSourceImage] = useState(null);
  const [profileOriginalFileName, setProfileOriginalFileName] = useState(null);
  // console.log(profileImage);
  const [profileModal, setprofileModal] = useState(false);
  const handleprofileModal = () => {
    setprofileModal(false);
  };
  const fileInputRefprofile = useRef(null);
  // const handleProfileClick = () => {
  //   fileInputRefprofile.current.click();
  // };
  // const handleProfileImageChange = (event) => {
  //   const selectedFile = event.target.files[0];

  //   setprofileImage(selectedFile);
  //   // setprofileImage(event.target.files[0].name);
  //   setselectedprofileImage(URL.createObjectURL(selectedFile));
  // };

  const handleProfileClick = () => {
    fileInputRefprofile.current.click();
  };

  const handleProfileImageChange = (event) => {
    const selectedFile = event.target.files[0];
    if (!selectedFile) return;
    const reader = new FileReader();
    reader.onload = () => {
      setProfileCropImage(reader.result);
      setProfileSourceImage(reader.result);
      setProfileOriginalFileName(selectedFile.name);
      try { sessionStorage.setItem("tempProfileImage", reader.result); } catch (e) { }
    };
    reader.readAsDataURL(selectedFile);
    // allow selecting the same file again later
    event.target.value = "";
  };
  const handleProfileModalClose = () => {
    setprofileModal(false);
  };
  const ProfileImageUpload = async () => {
    try {
      if (profileImage !== null) {
        const formData = new FormData();
        formData.append("DeviceType", "Web");
        formData.append("sessionId", sessionId);
        formData.append("ProfilPic", profileImage);
        formData.append("Language", language === "en" ? "" : language,);
        const res = await axios.post("/UserAccount/SetProfilePic", formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        });
        // console.log("response: ", res.data.responseData);
        // toast.success(res.data.message);
        setToastMessage(res.data.message);
        setShowToast(true);
        setprofileModal(false);
        userConfig({ forceRefresh: true });
        getUserProfilePer({ forceRefresh: true });
        getUserProfile()
        try { sessionStorage.removeItem("tempProfileImage"); } catch (e) { }
      }
    } catch (error) {
      if (error.response && error.response.status === 404) {
        setWarningToastMessage(error.response.data.message);
        setShowWarningToast(true);
      } else {
        setErrorToastMessage(error.response.data.message);
        setShowErrorToast(true);
      }
    }
  };
  //************************ Profile Picture End  ************************//

  //************************ Background Image   ************************//
  const [bgSelectedImage, setBgSelectedImage] = useState(null);
  const [backgroundImage, setBackgroundImage] = useState(null);
  const [bgCropImage, setBgCropImage] = useState(null);
  const [bgSourceImage, setBgSourceImage] = useState(null);
  const [bgOriginalFileName, setBgOriginalFileName] = useState(null);
  // inline crop states (shared)
  const [crop, setCrop] = useState({ x: 0, y: 0 });
  const [zoom, setZoom] = useState(1);
  const [rotation, setRotation] = useState(0);
  const [croppedAreaPixels, setCroppedAreaPixels] = useState(null);
  // console.log(backgroundImage);
  const [bgModal, setBgModal] = useState(false);
  const handleBgModal = () => {
    setBgModal(false);
  };
  const fileInputRefBg = useRef(null);
  const dobFlatpickrRef = useRef(null);
  const handleBgClick = () => {
    fileInputRefBg.current.click();
  };
  const handleBgImageChange = (event) => {
    const selectedFile = event.target.files[0];
    // setBackgroundImage(event.target.files[0].name);
    if (!selectedFile) return;
    const reader = new FileReader();
    reader.onload = () => {
      setBgCropImage(reader.result);
      setBgSourceImage(reader.result);
      setBgOriginalFileName(selectedFile.name);
      try { sessionStorage.setItem("tempBgImage", reader.result); } catch (e) { }
    };
    reader.readAsDataURL(selectedFile);
    // allow selecting the same file again later
    event.target.value = "";
  };

  // Crop callbacks
  const onCropComplete = useCallback((area, areaPixels) => {
    setCroppedAreaPixels(areaPixels);
  }, []);

  const saveProfileCroppedImage = async () => {
    try {
      if (!profileCropImage || !croppedAreaPixels) return;
      const croppedUrl = await getCroppedImg(profileCropImage, croppedAreaPixels, rotation);
      const response = await fetch(croppedUrl);
      const blob = await response.blob();
      const file = new File([blob], profileOriginalFileName || 'profile.jpg', { type: blob.type });
      setprofileImage(file);
      setselectedprofileImage(croppedUrl);
      try { sessionStorage.setItem("tempProfileImage", croppedUrl); } catch (e) { }
      setProfileCropImage(null);
      setprofileModal(true);
      setCrop({ x: 0, y: 0 });
      setZoom(1);
      setRotation(0);
      setCroppedAreaPixels(null);
    } catch (e) {
      console.error(e);
    }
  };

  const cancelProfileCropping = () => {
    setProfileCropImage(null);
    setCrop({ x: 0, y: 0 });
    setZoom(1);
    setRotation(0);
    setCroppedAreaPixels(null);
  };

  const deleteProfileSelection = () => {
    setselectedprofileImage(null);
    setprofileImage(null);
    setProfileOriginalFileName(null);
    setProfileSourceImage(null);
    setprofileModal(false);
    try { sessionStorage.removeItem("tempProfileImage"); } catch (e) { }
  };

  const saveBgCroppedImage = async () => {
    try {
      if (!bgCropImage || !croppedAreaPixels) return;
      const croppedUrl = await getCroppedImg(bgCropImage, croppedAreaPixels, rotation);
      const response = await fetch(croppedUrl);
      const blob = await response.blob();
      const file = new File([blob], bgOriginalFileName || 'background.jpg', { type: blob.type });
      setBackgroundImage(file);
      setBgSelectedImage(croppedUrl);
      try { sessionStorage.setItem("tempBgImage", croppedUrl); } catch (e) { }
      setBgCropImage(null);
      setBgModal(true);
      setCrop({ x: 0, y: 0 });
      setZoom(1);
      setRotation(0);
      setCroppedAreaPixels(null);
    } catch (e) {
      console.error(e);
    }
  };

  const cancelBgCropping = () => {
    setBgCropImage(null);
    setCrop({ x: 0, y: 0 });
    setZoom(1);
    setRotation(0);
    setCroppedAreaPixels(null);
  };

  const deleteBgSelection = () => {
    setBgSelectedImage(null);
    setBackgroundImage(null);
    setBgOriginalFileName(null);
    setBgSourceImage(null);
    setBgModal(false);
    try { sessionStorage.removeItem("tempBgImage"); } catch (e) { }
  };

  const BgImageUpload = async () => {
    try {
      if (backgroundImage !== null) {
        const formData = new FormData();
        formData.append("DeviceType", "Web");
        formData.append("sessionId", sessionId);
        formData.append("BackGroundImage", backgroundImage);
        formData.append("Language", language === "en" ? "" : language,);
        const res = await axios.post(
          "/UserAccount/SetBackgroundImage",
          formData,
          {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          }
        );
        // console.log("response: ", res.data.responseData);
        // toast.success(res.data.message);
        setToastMessage(res.data.message);
        setShowToast(true);
        setBgModal(false);
        userConfig({ forceRefresh: true });
        getUserProfilePer({ forceRefresh: true });
        getUserProfile()
        try { sessionStorage.removeItem("tempBgImage"); } catch (e) { }
      }
    } catch (error) {
      if (error.response && error.response.status === 404) {
        setWarningToastMessage(error.response.data.message);
        setShowWarningToast(true);
      } else {
        setErrorToastMessage(error.response.data.message);
        setShowErrorToast(true);
      }
    }
  };
  //************************ Background Image End  ************************//

  //************************ DOB   ************************//
  const [startDate, setStartDate] = useState(null);
  const [dob, setDob] = useState(false);
  const handledob = () => {
    setDob(false);
  };
  const DobUpload = async () => {
    try {
      if (startDate !== null) {
        const formData = new FormData();
        formData.append("DeviceType", "Web");
        formData.append("sessionId", sessionId);
        formData.append("Language", language === "en" ? "" : language,);
        formData.append(
          "Dob",
          startDate === "" ? "" : moment(startDate).format("YYYY-MM-DD")
        );
        const res = await axios.post("/UserAccount/SetDob", formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        });
        // console.log("response: ", res.data.responseData);
        // toast.success(res.data.message);
        setToastMessage(res.data.message);
        setShowToast(true);
        setDob(false);
        userConfig({ forceRefresh: true });
        getUserProfilePer({ forceRefresh: true });
        getUserProfile()
      }
    } catch (error) {
      if (error.response && error.response.status === 404) {
        setWarningToastMessage(error.response.data.message);
        setShowWarningToast(true);
      } else {
        setErrorToastMessage(error.response.data.message);
        setShowErrorToast(true);
      }
    }
  };
  //************************ DOB  End ************************//

  //************************ Gender   ************************//
  const [genderModal, setGenderModal] = useState(false);
  const handleGenderModal = () => {
    setGenderModal(false);
  };
  const [genderValue, setGenderValue] = useState(null);
  const [genderOptionList, setGenderOptionList] = useState([]);
  const getGenderData = () => {
    try {
      axios.get(`/Master/GetGenderDDL?LangKey=${language}`).then((response) => {
        // console.log("gender data", response.data.responseData);
        setGenderOptionList(response.data.responseData);
        // setLoading(false);
      });
    } catch (error) {
      console.log(error);
    }
  };

  let genderOptions = genderOptionList.map((val) => {
    return { value: val.gndrId, label: val.name, id: val.gndrId };
  });

  const selectGender = (val) => {
    // console.log("gender", val.value);
    setGenderValue(val.value);
  };

  useEffect(() => {
    getGenderData();
  }, []);

  const GenderUpload = async () => {
    try {
      if (genderValue !== null) {
        const formData = new FormData();
        formData.append("DeviceType", "Web");
        formData.append("sessionId", sessionId);
        formData.append("GndrId", genderValue);
        formData.append("Language", language === "en" ? "" : language,);
        const res = await axios.post("/UserAccount/SetGender", formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        });
        // console.log("response: ", res.data.responseData);
        // toast.success(res.data.message);
        setToastMessage(res.data.message);
        setShowToast(true);
        setGenderModal(false);
        userConfig({ forceRefresh: true });
        getUserProfilePer({ forceRefresh: true });
        getUserProfile()
      }
    } catch (error) {
      if (error.response && error.response.status === 404) {
        setWarningToastMessage(error.response.data.message);
        setShowWarningToast(true);
      } else {
        setErrorToastMessage(error.response.data.message);
        setShowErrorToast(true);
      }
    }
  };

  //************************ Gender End   ************************//

  //********City List Start  ********//
  const [cityData, setCityData] = useState([]);
  const [cityId, setCityId] = useState(null);
  const [citySearch, setCitySearch] = useState(null);
  const getCity = () => {
    axios
      .get(`Master/GetCitiesDDL?search=${citySearch}&LangKey=${language}`)
      .then((response) => {
        const res = response.data.responseData;
        const data = res.map((item) => ({
          value: item.cityId,
          label: item.cityName,
        }));
        setCityData(data);
      })
      .catch((error) => {
        console.log(error);
      });
  };
  useEffect(() => {
    if (citySearch) {
      getCity();
    }
  }, [citySearch]);
  //********City List End  ********//

  //************************ language   ************************//
  const [languageModal, setlanguageModal] = useState(false);
  const handlelanguageModal = () => {
    setlanguageModal(false);
  };
  const [languageValue, setlanguageValue] = useState(null);
  const [languageOptionList, setlanguageOptionList] = useState([]);
  const getlanguageData = () => {
    try {
      axios.get(`/Master/GetLanguageDDL?LangKey=${language}`).then((response) => {
        // console.log("language data", response.data.responseData);
        setlanguageOptionList(response.data.responseData);
        // setLoading(false);
      });
    } catch (error) {
      console.log(error);
    }
  };

  let languageOptions = languageOptionList.map((val) => {
    return { value: val.langId, label: val.name, id: val.langId };
  });

  const selectlanguage = (val) => {
    // console.log("language", val.value);
    setlanguageValue(val.value);
  };

  useEffect(() => {
    getlanguageData();
  }, []);

  const languageUpload = async () => {
    try {
      if (cityId !== null) {
        const formData = new FormData();
        formData.append("DeviceType", "Web");
        formData.append("sessionId", sessionId);
        formData.append("CityID", cityId);
        formData.append("Language", language === "en" ? "" : language,);
        const res = await axios.post("/UserAccount/SetCity", formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        });
        // console.log("response: ", res.data.responseData);
        // toast.success(res.data.message);
        setToastMessage(res.data.message);
        setShowToast(true);
        setlanguageModal(false);
        userConfig({ forceRefresh: true });
        getUserProfilePer({ forceRefresh: true });
        getUserProfile()
      }
    } catch (error) {
      if (error.response && error.response.status === 404) {
        setWarningToastMessage(error.response.data.message);
        setShowWarningToast(true);
      } else {
        setErrorToastMessage(error.response.data.message);
        setShowErrorToast(true);
      }
    }
  };

  //************************ Language End   ************************//

  //************************ About   ************************//
  const [length, setLength] = useState('');
  const [aboutContent, setAboutContent] = useState("");
  const [aboutModal, setAboutModal] = useState(false);
  const handleAboutModal = () => {
    setAboutModal(false);
  };
  const AboutUpload = async () => {
    try {
      if (aboutContent !== '') {
        const formData = new FormData();
        formData.append("DeviceType", "Web");
        formData.append("sessionId", sessionId);
        formData.append("AboutContent", aboutContent);
        formData.append("Language", language === "en" ? "" : language,);
        const res = await axios.post("/UserAccount/SetAbout", formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        });
        // console.log("response: ", res.data.responseData);
        // toast.success(res.data.message);
        setToastMessage(res.data.message);
        setShowToast(true);
        setAboutModal(false);
        userConfig({ forceRefresh: true });
        getUserProfilePer({ forceRefresh: true });
        getUserProfile()
      }
    } catch (error) {
      if (error.response && error.response.status === 404) {
        setWarningToastMessage(error.response.data.message);
        setShowWarningToast(true);
      } else {
        setErrorToastMessage(error.response.data.message);
        setShowErrorToast(true);
      }
    }
  };
  //************************ About  End ************************//

  //************************ Website   ************************//
  const [websitecontent, setWebsitecontent] = useState("");
  const [websiteModal, setWebsiteModal] = useState(false);
  const isValidWebsiteUrl = (value) => {
    const trimmedValue = value.trim();

    if (!trimmedValue) {
      return false;
    }

    try {
      const normalizedValue = /^https?:\/\//i.test(trimmedValue)
        ? trimmedValue
        : `https://${trimmedValue}`;
      const parsedUrl = new URL(normalizedValue);

      return Boolean(parsedUrl.hostname && parsedUrl.hostname.includes("."));
    } catch (validationError) {
      return false;
    }
  };

  const handlewebsiteModal = () => {
    setWebsiteModal(false);
  };
  const websiteUpload = async () => {
    // if (!websitecontent.trim() || error) {
    if (!isValidWebsiteUrl(websitecontent)) {
      // alert("Please provide a valid website URL.");
      setShowWarningToast(true);
      setWarningToastMessage("Please provide a valid website URL.");


      return;
    }
    try {
      if (websitecontent !== '') {
        const formData = new FormData();
        formData.append("DeviceType", "Web");
        formData.append("sessionId", sessionId);
        formData.append("Website", websitecontent.trim());
        formData.append("Language", language === "en" ? "" : language,);
        const res = await axios.post("/UserAccount/SetWebsite", formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        });
        // console.log("response: ", res.data.responseData);
        // toast.success(res.data.message);
        setToastMessage(res.data.message);
        setShowToast(true);
        setWebsiteModal(false);
        userConfig({ forceRefresh: true });
        getUserProfilePer({ forceRefresh: true });
        getUserProfile()
      }
    } catch (error) {
      if (error.response && error.response.status === 404) {
        setWarningToastMessage(error.response.data.message);
        setShowWarningToast(true);
      } else {
        setErrorToastMessage(error.response.data.message);
        setShowErrorToast(true);
      }
    }
  };
  //************************ Website  End ************************//

  //************************User Profile Stats Start  ************************//
  const [userPer, setUserPer] = useState([]);
  const [animatedPercentage, setAnimatedPercentage] = useState(0);
  const [percentageRefreshKey, setPercentageRefreshKey] = useState(0);
  const getUserProfilePer = async ({ forceRefresh = false } = {}) => {
    try {
      const res = await getProfilePercentage({ forceRefresh });
      if (!res) return;
      console.log("userprofilestat", res);
      localStorage.setItem("ProfilePercentage", res.percentage);
      setUserPer(res);
      setAnimatedPercentage(0);
      setPercentageRefreshKey((key) => key + 1);
    } catch (error) {
      console.log(error);
    }
  };

  // Animate the progress bar
  useEffect(() => {
    if (userPer?.percentage != null) {
      const targetPercentage = Number(userPer.percentage);
      let currentPercentage = 0;
      const increment = targetPercentage / 50; // Animate over ~50 frames

      const interval = setInterval(() => {
        currentPercentage += increment;
        if (currentPercentage >= targetPercentage) {
          setAnimatedPercentage(targetPercentage);
          clearInterval(interval);
        } else {
          setAnimatedPercentage(currentPercentage);
        }
      }, 30); // Update every 30ms for smooth animation

      return () => clearInterval(interval);
    }
  }, [userPer?.percentage, percentageRefreshKey]);

  useEffect(() => {
    getUserProfilePer();
  }, [sessionId]);

  useEffect(() => {
    const refreshProfileScore = () => {
      getUserProfilePer({ forceRefresh: true });
      userConfig({ forceRefresh: true });
    };
    window.addEventListener("profileScoreRefresh", refreshProfileScore);
    return () =>
      window.removeEventListener("profileScoreRefresh", refreshProfileScore);
  }, []);

  //************************User Profile Stats End  ************************//

  const customStyles = {
    option: (provided, state) => ({
      ...provided,
      className: state.isFocused
        ? "react-select__option--is-focused"
        : state.isSelected
          ? "react-select__option--is-selected"
          : "",
    }),
  };

  useEffect(() => {
    if (
      websiteModal ||
      aboutModal ||
      languageModal ||
      genderModal ||
      dob ||
      bgModal ||
      profileModal
    ) {
      document.body.style.overflow = 'hidden';
      document.documentElement.style.overflow = 'hidden';
      document.body.classList.add('modal-open'); // When a modal opens
    } else {
      document.body.style.overflow = 'unset';
      document.documentElement.style.overflow = '';
      document.body.classList.remove('modal-open'); // When a modal closes
    }
  }, [
    websiteModal,
    aboutModal,
    languageModal,
    genderModal,
    dob,
    bgModal,
    profileModal,
  ]);
  console.log('profileConfig', profileConfig);
  const preventYearScroll = (datePickerInstance) => {
    const yearElement = datePickerInstance.currentYearElement;
    if (yearElement) {
      yearElement.addEventListener("wheel", (e) => {
        e.preventDefault(); // Stops mouse scroll
      });
    }
  };

  const EnableUserCCV = async () => {
    const responseData = {
      deviceType: "Web",
      sessionId: sessionId,
      rsmID: UserCcvid,
      langKey: language === "en" ? "" : language,
    };
    try {
      await axios.put(`ResumeAction/EnableResume`, responseData).then((res) => {
        setToastMessage(res.data.message);
        setShowToast(true);
        CheckUserCcv();
      });
    } catch (error) {
      console.log(error.response.data.message);
      if (error.response && error.response.status === 404) {
        setWarningToastMessage(error.response.data.message);
        setShowWarningToast(true);
      } else {
        setErrorToastMessage(error.response.data.message);
        setShowErrorToast(true);
      }
    }
  };
  const RestoreResume = async () => {
    const responseData = {
      deviceType: "Web",
      sessionId: sessionId,
      rsmID: UserCcvid,
      langKey: language === "en" ? "" : language,
    };
    try {
      await axios
        .post(`ResumeAction/RestoreResume`, responseData)
        .then((res) => {
          setToastMessage(res.data.message);
          setShowToast(true);
          CheckUserCcv()
        });
    } catch (error) {
      console.log(error.response.data.message);
      if (error.response && error.response.status === 404) {
        setWarningToastMessage(error.response.data.message);
        setShowWarningToast(true);
      } else {
        setErrorToastMessage(error.response.data.message);
        setShowErrorToast(true);
      }
    }
  };

  const renderResumeAction = ({ standalone = false } = {}) => {
    const colClass = standalone
      ? "d-flex align-items-center pointer"
      : "col-md-4 d-flex mb-2 align-items-center";

    if (userCcv === "Deleted") {
      return (
        <div
          className={`${colClass} circle pointer`}
          onClick={() => RestoreResume()}
        >
          <RestoreIcon className="material-symbols-sharp " />
          <p className="f-14 fw-bold ms-1">{t("Newsfeed.Restore Resume")}</p>
        </div>
      );
    }
    if (userCcv === "Deactivated") {
      return (
        <div
          className={`${colClass} circle pointer`}
          onClick={EnableUserCCV}
        >
          <DoDisturbOnOutlinedIcon className="material-symbols-sharp " />
          <p className="f-14 fw-bold ms-1">{t("Newsfeed.Activate Resume")}</p>
        </div>
      );
    }
    if (userCcv === "NotFound") {
      return (
        <div
          className={`${colClass} circle pointer`}
          style={{ cursor: "pointer" }}
          onClick={AddUserCcv}
        >
          <AddCircleSharpIcon className="material-symbols-sharp " />
          <p className="f-14 fw-bold ms-1" style={{ cursor: "pointer" }}>
            {t("Newsfeed.Create Resume")}
          </p>
        </div>
      );
    }
    if (userCcv === "Active") {
      return (
        <div className={`${colClass} circle pointer`} style={{ cursor: "pointer" }}>
          <Link
            to={`/ManageResume/${userUid}`}
            className="d-flex align-items-center text-decoration-none text-reset"
            style={{ cursor: "pointer" }}
          >
            <CheckCircleOutlineSharpIcon className="material-symbols-sharp check" />
            <p className="f-14 fw-bold ms-1 mb-0 text-nowrap" style={{ cursor: "pointer" }}>
              {t("User Profile.Manage Resume")}
            </p>
          </Link>
        </div>
      );
    }
    return (
      <div className={`${colClass} circle disabled`}>
        <AddCircleSharpIcon className="material-symbols-sharp " />
        <p className="f-14 fw-bold ms-1">{t("Newsfeed.Create Resume")}</p>
      </div>
    );
  };

  const hasBackgroundImageFilled =
    profileConfig?.hasBackgroundImage === true ||
    Boolean(profileInfo?.backGroundImage);

  const isProfileComplete =
    profileConfig?.hasProfileImage &&
    hasBackgroundImageFilled &&
    profileConfig?.hasDob &&
    profileConfig?.hasCity &&
    profileConfig?.hasGender &&
    profileConfig?.hasAbout &&
    profileConfig?.hasWebsite &&
    profileConfig?.hasCcv;

  // Prefer live profile data when present so warning stays accurate after Basic Info save,
  // even if GetUserConfig cache briefly lags.
  const hasDobFilled =
    profileConfig?.hasDob === true || Boolean(profileInfo?.dob);
  const hasGenderFilled =
    profileConfig?.hasGender === true ||
    Boolean(profileInfo?.genderId || profileInfo?.genderName);
  const hasCityFilled =
    profileConfig?.hasCity === true ||
    Boolean(profileInfo?.cityID || profileInfo?.cityName);

  const missingResumeProfileFields = [
    !hasDobFilled && t("User Profile.DOB"),
    !hasGenderFilled && t("User Profile.Gender"),
    !hasCityFilled && t("User Profile.City"),
  ].filter(Boolean);

  const resumeProfileWarningMessage =
    missingResumeProfileFields.length > 0
      ? t("modals.Provide details for {{fields}} information to manage your resume.", {
        fields: missingResumeProfileFields.join(", "),
      })
      : "";

  const refreshAfterBasicInfoSave = () => {
    getUserProfile();
    userConfig({ forceRefresh: true });
    getUserProfilePer({ forceRefresh: true });
  };

  return (
    <>
      {profileCropImage ? (
        <Portal layer="modal">
          <div className="modal fade show postAdd wlj-overlay-modal" tabIndex="-1" role="dialog" style={{ display: "flex" }}>
            <div className="modal-dialog modal-dialog-centered" role="document">
              <div className="modal-content d-flex justify-content-around p-2">
                <div className="modalBorder d-flex justify-content-between align-items-center p-2">
                  <h6>{t("modals.Profile Pic")}</h6>
                  <CloseSharpIcon className="material-symbols-sharp me-2 pointer" onClick={cancelProfileCropping} />
                </div>
                <div className="cropperContianer">
                  {profileCropImage && (
                    <div className="crop-app">
                      <div className="bg-crop-wrapper" style={{ position: "relative", height: 300, width: "100%" }}>
                        <Cropper
                          image={profileCropImage}
                          crop={crop}
                          zoom={zoom}
                          style={{ height: 200, width: "100%" }}
                          rotation={rotation}
                          aspect={1 / 1}
                          onCropChange={setCrop}
                          onCropComplete={onCropComplete}
                          onRotationChange={setRotation}
                          onZoomChange={setZoom}
                        />
                      </div>
                    </div>
                  )}
                </div>
                <div className="text-end mt-3 mb-3 me-3">
                  <button className="closebtn me-2" onClick={cancelProfileCropping}>{t("Connections.Cancel")}</button>
                  <button className="mainBtn1" onClick={saveProfileCroppedImage}>{t("Newsfeed.Apply Crop")}</button>
                </div>
              </div>
            </div>
          </div>
        </Portal>
      ) : null}
      {bgCropImage ? (
        <Portal layer="modal">
          <div className="modal fade show postAdd wlj-overlay-modal" tabIndex="-1" role="dialog" style={{ display: "flex" }}>
            <div className="modal-dialog modal-dialog-centered" role="document">
              <div className="modal-content d-flex justify-content-around p-2">
                <div className="modalBorder d-flex justify-content-between align-items-center p-2">
                  <h6>{t("modals.Background Image")}</h6>
                  <CloseSharpIcon className="material-symbols-sharp me-2 pointer" onClick={cancelBgCropping} />
                </div>
                <div className="cropperContianer">
                  {bgCropImage && (
                    <div className="crop-app">
                      <div className="bg-crop-wrapper" style={{ position: "relative", height: 400, width: "100%" }}>
                        <Cropper
                          image={bgCropImage}
                          crop={crop}
                          zoom={zoom}
                          style={{ height: 150, width: "100%" }}
                          rotation={rotation}
                          aspect={16 / 5}
                          onCropChange={setCrop}
                          onCropComplete={onCropComplete}
                          onRotationChange={setRotation}
                          onZoomChange={setZoom}
                        />
                      </div>
                    </div>
                  )}
                </div>
                <div className="text-end mt-3 mb-3 me-3">
                  <button className="closebtn me-2" onClick={cancelBgCropping}>{t("Connections.Cancel")}</button>
                  <button className="mainBtn1" onClick={saveBgCroppedImage}>{t("Newsfeed.Apply Crop")}</button>
                </div>
              </div>
            </div>
          </div>
        </Portal>
      ) : null}
      <div className="UpdateProfile mb-3 p-2 new-UpdateProfile">
        <div
          className={`d-flex justify-content-between align-items-center mb-2${!isProfileComplete ? " border-custom pb-2" : ""
            }`}
        >
          <p className="f-16 fw-bold mb-0">
            {isProfileComplete
              ? t("User Profile.Your profile score")
              : t("User Profile.Complete Your Profile")}
          </p>
          {!isProfileComplete && (
            <EditSharpIcon
              className="material-symbols-sharp pointer"
              onClick={() => setBasicInfoModal(true)}
            />
          )}
        </div>

        <div className="d-flex mt-2 align-items-center w-100">
          <Progress
            style={{ height: "6px", flex: 1 }}
            value={animatedPercentage}
            color={
              userPer?.percentage < 30
                ? "danger"
                : userPer?.percentage > 80
                  ? "success"
                  : userPer?.percentage > 30 && userPer?.percentage < 60
                    ? "warning"
                    : "info"
            }
            className="progress-animated"
          />
          <span className="f-14 ms-4">{userPer?.percentage}%</span>
        </div>
        {profileConfig && Object.keys(profileConfig).length > 0 ? (
          showResumeModal || missingResumeProfileFields.length === 0 ? null : (
            <p className="warningText my-2 d-flex UpdatewarningText">
              <WarningAmberSharpIcon style={{ fontSize: "16px" }} />
              {t("modals.Warning")} : {resumeProfileWarningMessage}
            </p>
          )
        ) : (
          <p>{t("modals.Loading")}</p>
        )}

        {!isProfileComplete && (
          <div className="row">
            {profileConfig.hasProfileImage === true ? (null
              // <div className="col-md-4 d-flex mb-2 align-items-center ">
              //   <CheckCircleOutlineSharpIcon className="material-symbols-sharp check" />
              //   <p className="f-14 ms-1">{t("User Profile.Profile picture uploaded")}</p>
              // </div>
            ) : (<>
              <div className="col-md-4 d-flex circle mb-2 pointer">
                <AddCircleSharpIcon className="material-symbols-sharp " />
                <p
                  className="f-14 fw-bold ms-1"
                  onClick={() => {
                    // setprofileModal(true);
                    handleProfileClick();
                  }}
                >
                  {t("modals.Add Profile Picture")}
                </p>
              </div>
              <input
                type="file"
                ref={fileInputRefprofile}
                style={{ display: "none" }}
                onChange={handleProfileImageChange}
                accept="image/*"
              />
            </>
            )}
            {hasBackgroundImageFilled ? (null
              // <div className="col-md-4 d-flex mb-2 align-items-center">
              //   <CheckCircleOutlineSharpIcon className="material-symbols-sharp check" />
              //   <p className="f-14 ms-1">{t("User Profile.Background Image uploaded")} </p>
              // </div>
            ) : (<>
              <div
                className="col-md-4 d-flex circle mb-2 pointer"
                onClick={() => {
                  // setBgModal(true);
                  handleBgClick();
                }}
              >
                <AddCircleSharpIcon className="material-symbols-sharp " />
                <p className="f-14 fw-bold ms-1">
                  {t("User Profile.Add Background Image")}
                </p>
              </div>
              <input
                type="file"
                ref={fileInputRefBg}
                style={{ display: "none" }}
                onChange={handleBgImageChange}
                accept="image/*"
              />
            </>
            )}
            {hasDobFilled ? (null
              // <div className="col-md-4 d-flex mb-2 align-items-center">
              //   <CheckCircleOutlineSharpIcon className="material-symbols-sharp check" />
              //   <p className="f-14 ms-1">{t("User Profile.DOB")}</p>
              // </div>
            ) : (
              <div
                className="col-md-4 d-flex mb-2 align-items-center circle pointer"
                onClick={() => {
                  setDob(true);
                }}
              >
                <AddCircleSharpIcon className="material-symbols-sharp " />
                <p className="f-14 fw-bold ms-1">{t("User Profile.DOB")}</p>
              </div>
            )}
            {hasCityFilled ? (null
              // <div className="col-md-4 d-flex mb-2 align-items-center">
              //   <CheckCircleOutlineSharpIcon className="material-symbols-sharp check" />
              //   <p className="f-14 ms-1">{t("User Profile.City")}</p>
              // </div>
            ) : (
              <div
                className="col-md-4 d-flex mb-2 align-items-center circle pointer"
                onClick={() => {
                  setlanguageModal(true);
                }}
              >
                <AddCircleSharpIcon className="material-symbols-sharp " />
                <p className="f-14 fw-bold ms-1">{t("User Profile.City")}</p>
              </div>
            )}

            {hasGenderFilled ? (null
              // <div className="col-md-4 d-flex mb-2 align-items-center">
              //   <CheckCircleOutlineSharpIcon className="material-symbols-sharp check" />
              //   <p className="f-14 ms-1"> {t("User Profile.Gender")} </p>
              // </div>
            ) : (
              <div
                className="col-md-4 d-flex mb-2 align-items-center circle pointer"
                onClick={() => {
                  setGenderModal(true);
                }}
              >
                <AddCircleSharpIcon className="material-symbols-sharp " />
                <p className="f-14 fw-bold ms-1">{t("User Profile.Gender")}</p>
              </div>
            )}

            {profileConfig.hasAbout === true ? (null
              // <div className="col-md-4 d-flex align-items-center">
              // //   <CheckCircleOutlineSharpIcon className="material-symbols-sharp check"/>
              // //   <p className="f-14 ms-1">{t("User Profile.About")}</p>
              // </div>
            ) : (
              <div
                className="col-md-4 d-flex align-items-center circle pointer"
                onClick={() => {
                  setAboutModal(true);
                }}
              >
                <AddCircleSharpIcon className="material-symbols-sharp " />
                <p className="f-14 fw-bold ms-1">{t("User Profile.About")}</p>
              </div>
            )}
            {profileConfig.hasWebsite === true ? (null
              // <div className="col-md-4 d-flex align-items-center">
              //   <CheckCircleOutlineSharpIcon className="material-symbols-sharp check" />
              //   <p className="f-14 ms-1"> {t("User Profile.Website")}</p>
              // </div>
            ) : (
              <div
                className="col-md-4 d-flex align-items-center circle pointer"
                onClick={() => {
                  setWebsiteModal(true);
                }}
              >
                <AddCircleSharpIcon className="material-symbols-sharp " />
                <p className="f-14 fw-bold ms-1">{t("User Profile.Website")}</p>
              </div>
            )}

            {renderResumeAction()}

          </div>
        )}
      </div>

      {isProfileComplete && userCcv && (
        <div className="UpdateProfile mb-3 p-2 new-UpdateProfile">
          {renderResumeAction({ standalone: true })}
        </div>
      )}

      {basicInfoModal && (
        <ProfileBasicInfoModal
          onClose={() => setBasicInfoModal(false)}
          getUserProfile={refreshAfterBasicInfoSave}
          initialProfileInfo={profileInfo}
        />
      )}

      {/* {profileModal && (
        <Portal layer="modal">
        <div
          className="modal fade show postAdd wlj-overlay-modal"
          tabIndex="-1"
          role="dialog"
          style={{ display: "flex" }}
        >
          <div className="modal-dialog  modal-dialog-centered " role="document">
            <div className="modal-content d-flex justify-content-around">
              <div className="modalBorder d-flex justify-content-between align-items-center p-2">
                <h6>Add Profile Image</h6>
                <CloseSharpIcon className="material-symbols-sharp me-2 pointer"
                  onClick={() => {
                    handleprofileModal();
                  }} />
              </div>
              <div className="d-flex justify-content-center">
                <div>
                  
                  <div className="d-flex justify-content-center align-items-center mb-2 mt-2">
                    <div className="uploadImage-cont">
                      <img
                        src={userAuthImage.dummy1}
                        alt="Upload here"
                        style={{
                          cursor: "pointer",
                          width: "100%",
                        }}
                        onClick={handleProfileClick}
                      />
                    </div>
                    <p>Choose File</p>
                  </div>

                  <div className="empty-line mb-3"></div>
                  <input
                    type="file"
                    ref={fileInputRefprofile}
                    style={{ display: "none" }}
                    onChange={handleProfileImageChange}
                    accept="image/*"
                  />
                </div>
              </div>
              <div className="uploaded-imagebg m-2 d-flex justify-content-center">
                {selectedprofileImage && (
                  <img src={selectedprofileImage} alt="Selected" height={200} />
                )}
              </div>
              <div className="col-md-12 text-end mb-3 me-2 d-flex justify-content-end">
                <button
                  type="button"
                  className="mainBtn1 me-4"
                  onClick={ProfileImageUpload}
                >
                  Submit
                </button>
              </div>
            </div>
          </div>
        </div>
        </Portal>
      )} */}

      {profileModal && (
        <Portal layer="modal">
          <div
            className="modal fade show postAdd wlj-overlay-modal"
            tabIndex="-1"
            role="dialog"
            style={{ display: "flex" }}
          >
            <div className="modal-dialog  modal-dialog-centered " role="document">
              <div className="modal-content d-flex justify-content-around p-2">
                <div className="modalBorder d-flex justify-content-between align-items-center p-2">
                  <h6>{t("modals.Profile Pic")} </h6>
                  <CloseSharpIcon
                    className="material-symbols-sharp me-2 pointer"
                    onClick={handleProfileModalClose}
                  />
                </div>
                <div className="d-flex">

                </div>
                <div className="uploaded-imagebg mt-2">
                  {selectedprofileImage && (
                    <div className="preview-container text-center position-relative d-inline-block" style={{ width: "100%" }}>
                      <div className="crop-app">
                        <div className="bg-crop-wrapper" style={{ position: "relative", height: 400, width: "100%" }}>
                          <Cropper
                            image={selectedprofileImage}
                            crop={crop}
                            zoom={zoom}
                            style={{ height: 200, width: "100%" }}
                            rotation={rotation}
                            aspect={1 / 1}
                            onCropChange={setCrop}
                            onCropComplete={onCropComplete}
                            onRotationChange={setRotation}
                            onZoomChange={setZoom}
                          />
                        </div>
                      </div>

                      <div className="pt-2 old-button-area d-flex justify-content-center gap-2">
                        <span
                          className="pointer"
                          style={{ backgroundColor: "gainsboro", padding: "7px 10px 10px 10px", borderRadius: "50%" }}
                          onClick={() => {
                            setprofileModal(false);
                            setProfileCropImage(profileSourceImage || selectedprofileImage);
                          }}
                        >
                          <EditSharpIcon className="material-symbols-sharp" />
                        </span>

                        <span
                          className="pointer"
                          style={{ backgroundColor: "gainsboro", padding: "7px 10px 10px 10px", borderRadius: "50%" }}
                          onClick={() => {
                            deleteProfileSelection();
                          }}
                        >
                          <DeleteSharpIcon className="material-symbols-sharp" />
                        </span>
                      </div>
                    </div>
                  )}
                </div>
                <div className="col-md-12 text-end mt-4">
                  <button
                    type="button"
                    className="mainBtn1"
                    onClick={ProfileImageUpload}
                  >
                    {t("User Profile.Submit")}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </Portal>
      )}
      {/* {bgModal && (
        <Portal layer="modal">
        <div
          className="modal fade show postAdd wlj-overlay-modal"
          tabIndex="-1"
          role="dialog"
          style={{ display: "flex" }}
        >
          <div className="modal-dialog  modal-dialog-centered " role="document">
            <div className="modal-content d-flex justify-content-around">
              <div className="modalBorder d-flex justify-content-between align-items-center p-2">
                <h6>Add Background Image</h6>
                <CloseSharpIcon className="material-symbols-sharp me-2 pointer"
                  onClick={() => {
                    handleBgModal();
                  }} />
              </div>
              <div className="d-flex d-flex justify-content-center">
                <div>

                  <div className="d-flex justify-content-center align-items-center mb-2 mt-2">
                    <div className="uploadImage-cont">
                      <img
                        src={userAuthImage.dummy1}
                        alt="Upload here"
                        style={{
                          cursor: "pointer",
                          width: "100%",
                        }}
                        onClick={handleBgClick}
                      />
                    </div>
                    <p>Choose File</p>
                  </div>

                  <div className="empty-line mb-3"></div>
                  <input
                    type="file"
                    ref={fileInputRefBg}
                    style={{ display: "none" }}
                    onChange={handleBgImageChange}
                    accept="image/*"
                  />
                </div>
              </div>
              <div className="uploaded-imagebg mt-2 d-flex justify-content-center">
                {bgSelectedImage && (
                  <img src={bgSelectedImage} alt="Selected" height={200} />
                )}
              </div>

              <div className="col-md-12 text-end mt-4 mb-2 d-flex justify-content-end">
                <button
                  type="button"
                  className="mainBtn1 me-4"
                  onClick={BgImageUpload}
                >
                  Submit
                </button>
              </div>
            </div>
          </div>
        </div>
        </Portal>
      )} */}

      {bgModal && (
        <Portal layer="modal">
          <div
            className="modal fade show postAdd wlj-overlay-modal"
            tabIndex="-1"
            role="dialog"
            style={{ display: "flex" }}
          >
            <div className="modal-dialog  modal-dialog-centered " role="document">
              <div className="modal-content d-flex justify-content-around p-2">
                <div className="modalBorder d-flex justify-content-between align-items-center p-2">
                  <h6>{t("modals.Background Image")}</h6>
                  <CloseSharpIcon
                    className="material-symbols-sharp me-2 pointer"
                    onClick={() => {
                      handleBgModal();
                    }}
                  />
                </div>

                <div className=" mt-2">
                  {bgSelectedImage && (
                    <div className="preview-container text-center position-relative d-inline-block" style={{ width: "100%" }}>
                      <div className="crop-app">
                        <div className="bg-crop-wrapper" style={{ position: "relative", height: 400, width: "100%" }}>
                          <Cropper
                            image={bgSelectedImage}
                            crop={crop}
                            zoom={zoom}
                            style={{ height: 150, width: "100%" }}
                            rotation={rotation}
                            aspect={16 / 5}
                            onCropChange={setCrop}
                            onCropComplete={onCropComplete}
                            onRotationChange={setRotation}
                            onZoomChange={setZoom}
                          />
                        </div>
                      </div>

                      <div className="pt-2 old-button-area d-flex justify-content-center gap-2">
                        <span
                          className="pointer"
                          style={{ backgroundColor: "gainsboro", padding: "7px 10px 10px 10px", borderRadius: "50%" }}
                          onClick={() => {
                            setBgModal(false);
                            setBgCropImage(bgSourceImage || bgSelectedImage);
                          }}
                        >
                          <EditSharpIcon className="material-symbols-sharp" />
                        </span>

                        <span
                          className="pointer"
                          style={{ backgroundColor: "gainsboro", padding: "7px 10px 10px 10px", borderRadius: "50%" }}
                          onClick={() => {
                            deleteBgSelection();
                          }}
                        >
                          <DeleteSharpIcon className="material-symbols-sharp" />
                        </span>
                      </div>
                    </div>
                  )}
                </div>

                <div className="col-md-12 text-end mt-4">
                  <button
                    type="button"
                    className="mainBtn1"
                    onClick={BgImageUpload}
                  >
                    {t("User Profile.Submit")}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </Portal>
      )}

      {dob && (
        <Portal layer="modal">
          <div
            className="modal fade show postAdd wlj-overlay-modal"
            tabIndex="-1"
            role="dialog"
            style={{ display: "flex" }}
          >
            <div className="modal-dialog  modal-dialog-centered " role="document">
              <div className="modal-content d-flex justify-content-around">
                <div className="modalBorder d-flex justify-content-between align-items-center p-2">
                  <h6>{t("User Profile.DOB")}</h6>
                  <CloseSharpIcon
                    className="material-symbols-sharp pointer"
                    onClick={() => {
                      handledob();
                    }}
                  />
                </div>
                <div className="d-flex p-2 wlj-modal-body">
                  <div className="col-12 mt-2 px-2 mb-2 userInput d-flex align-items-stretch flex-column w-100">
                    <label htmlFor="dob">{t("User Profile.DOB")}<span className="text-danger ms-2">*</span></label>
                    <div className="dateofbirth w-100 position-relative">
                      <Flatpickr
                        className="form-control w-100"
                        style={{ paddingRight: "2.5rem" }}
                        value={startDate}
                        onChange={(date) => setStartDate(date[0])}
                        id="dob"
                        placeholder={t("Common.SelectDate")}
                        onCreate={(fp) => {
                          dobFlatpickrRef.current = fp;
                        }}
                        onDestroy={() => {
                          dobFlatpickrRef.current = null;
                        }}
                        options={{
                          maxDate: "today",// Disables future dates
                          onReady: (selectedDates, dateStr, instance) => {
                            preventYearScroll(instance); // Call the function to stop scroll on year
                          },
                          onOpen: (selectedDates, dateStr, instance) => {
                            preventYearScroll(instance); // Also prevent scroll when the picker opens
                          },
                        }}
                      />
                      <CalendarMonthSharpIcon
                        className="material-symbols-sharp position-absolute top-50 translate-middle-y pointer text-secondary"
                        style={{ right: "12px" }}
                        onClick={() => dobFlatpickrRef.current?.open()}
                      />
                    </div>
                  </div>
                </div>

                <div className="col-md-12 text-end mt-4 mb-2 d-flex justify-content-end">
                  <button
                    type="button"
                    className="mainBtn1 me-2"
                    onClick={DobUpload}
                  >
                    {t("User Profile.Submit")}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </Portal>
      )}

      {genderModal && (
        <Portal layer="modal">
          <div
            className="modal fade show postAdd wlj-overlay-modal"
            tabIndex="-1"
            role="dialog"
            style={{ display: "flex" }}
          >
            <div className="modal-dialog  modal-dialog-centered " role="document">
              <div className="modal-content d-flex justify-content-around">
                <div className="modalBorder d-flex justify-content-between align-items-center p-2">
                  <h6>{t("User Profile.Gender")}</h6>
                  <CloseSharpIcon
                    className="material-symbols-sharp me-2 pointer"
                    onClick={() => {
                      handleGenderModal();
                    }}
                  />
                </div>
                <div className="d-flex p-2 wlj-modal-body">
                  <div className="col-md-12 mt-2 ps-0 mb-2 userInput d-flex flex-column">
                    <div className="col-md-12">
                      <label htmlFor="gender">{t("User Profile.Gender")}<span className="text-danger ms-2">*</span></label>
                      <ReactSelect
                        options={genderOptions}
                        onChange={selectGender}
                        loadOptions={selectGender}
                        placeholder={t("Newsfeed.Select Gender")}
                        styles={customStyles}
                        classNamePrefix="react-select"
                      />
                    </div>
                  </div>
                </div>

                <div className="col-md-12 text-end mt-4 mb-2 d-flex justify-content-end">
                  <button
                    type="button"
                    className="mainBtn1 me-4"
                    onClick={GenderUpload}
                  >
                    {t("User Profile.Submit")}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </Portal>
      )}

      {languageModal && (
        <Portal layer="modal">
          <div
            className="modal fade show postAdd wlj-overlay-modal"
            tabIndex="-1"
            role="dialog"
            style={{ display: "flex" }}
          >
            <div className="modal-dialog  modal-dialog-centered " role="document">
              <div className="modal-content d-flex justify-content-around">
                <div className="modalBorder d-flex justify-content-between align-items-center p-2">
                  <h6>{t("Manage Companies.City")}</h6>
                  <CloseSharpIcon
                    className="material-symbols-sharp me-2 pointer"
                    onClick={() => {
                      handlelanguageModal();
                    }}
                  />
                </div>
                <div className="d-flex p-2 wlj-modal-body">
                  <div className="col-md-12 mt-2 ps-0 mb-2 userInput d-flex flex-column">
                    <div className="col-md-12 mt-2">
                      <label htmlFor="city">{t("User Profile.City")}<span className="text-danger ms-2">*</span></label>
                      {/* <ReactSelect
                      options={languageOptions}
                      onChange={selectlanguage}
                      loadOptions={selectlanguage}
                      placeholder={t("Common.SelectLanguage")}
                      styles={customStyles}
                    /> */}
                      <Select
                        defaultValue={cityId}
                        onChange={(selectedOption) =>
                          setCityId(selectedOption.value)
                        }
                        options={cityData}
                        noOptionsMessage={() => t("modals.Search and Select City")}
                        placeholder={t("modals.Search and Select City")}
                        onInputChange={(inputValue) => {
                          setCitySearch(inputValue);
                        }}
                        styles={customStyles}
                      />
                    </div>
                  </div>
                </div>

                <div className="col-md-12 text-end mt-4 mb-2 d-flex justify-content-end">
                  <button
                    type="button"
                    className="mainBtn1 me-4"
                    onClick={languageUpload}
                  >
                    {t("User Profile.Submit")}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </Portal>
      )}

      {aboutModal && (
        <Portal layer="modal">
          <div
            className="modal fade show postAdd wlj-overlay-modal"
            tabIndex="-1"
            role="dialog"
            style={{ display: "flex" }}
          >
            <div className="modal-dialog  modal-dialog-centered " role="document">
              <div className="modal-content d-flex justify-content-around">
                <div className="modalBorder d-flex justify-content-between align-items-center p-2">
                  <h6>{t("Sidemenubar.About")}</h6>
                  <CloseSharpIcon
                    className="material-symbols-sharp me-0 pointer"
                    onClick={() => {
                      handleAboutModal();
                    }}
                  />
                </div>

                <div className="d-flex p-2 wlj-modal-body">
                  <div className="col-md-12 mt-2 ps-0 mb-2 userInput d-flex flex-column align-items-center">
                    <div className="col-md-12 mt-2 about-textArea">
                      {/* <textarea
                      id="address"
                      name="about"
                      rows="4"
                      cols="55"
                      value={aboutContent}
                      onChange={(e) => setAboutContent(e.target.value)}
                    ></textarea> */}
                      <textarea
                        id="address"
                        name="about"
                        rows="4"
                        cols="55"
                        value={aboutContent}
                        onChange={(e) => {
                          setAboutContent(e.target.value)
                          setLength(e.target?.value.length)
                        }}
                        maxLength={500}
                      ></textarea>
                      <p className='info'>{aboutContent?.length && length}/500</p>
                    </div>
                  </div>
                </div>
                <p className="p-2 text-danger f-14">
                  {t("User Profile.About content should be less than 500 words")}
                </p>
                <div className="col-md-12 text-end mt-4 mb-2 d-flex justify-content-end px-2 wlj-about-modal-footer">
                  <button
                    type="button"
                    className="mainBtn1 me-0"
                    onClick={AboutUpload}
                  >
                    {t("User Profile.Submit")}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </Portal>
      )}

      {websiteModal && (
        <Portal layer="modal">
          <div
            className="modal fade show postAdd wlj-overlay-modal"
            tabIndex="-1"
            role="dialog"
            style={{ display: "flex" }}
          >
            <div className="modal-dialog  modal-dialog-centered " role="document">
              <div className="modal-content d-flex justify-content-around p-2">
                <div className="modalBorder d-flex justify-content-between align-items-center p-2">
                  <h6>{t("Company Profile.Website")}</h6>
                  <CloseSharpIcon
                    className="material-symbols-sharp me-2 pointer"
                    onClick={() => {
                      handlewebsiteModal();
                    }}
                  />
                </div>
                <div>
                  <div className="d-flex p-2 wlj-modal-body">
                    <p>{t("User Profile.Add Link at here")}</p>
                    <div className="col-md-12 mt-2 ps-0 mb-2 userInput d-flex flex-column align-items-center">
                      <div className="col-md-12 mt-2 web-input">
                        {/* <label htmlFor="about" className="web-text">Website </label> */}
                        <input
                          type="text"
                          style={{ width: "100%" }}
                          value={websitecontent}
                          onChange={(e) => setWebsitecontent(e.target.value)}
                        />
                      </div>
                    </div>
                  </div>
                </div>

                <div className="col-md-12 text-end mt-4 mb-2 d-flex justify-content-end">
                  <button
                    type="button"
                    className="mainBtn1 me-4"
                    onClick={websiteUpload}
                  >
                    {t("User Profile.Submit")}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </Portal>
      )}

      {showResumeModal && (
        <>
          <div className="modal-backdrop fade show" />
          <Portal layer="modal">
            <div
              className="modal fade show modal-md wlj-overlay-modal"
              tabIndex="-1"
              role="dialog"
              style={{ display: "flex" }}
            >
              <div className="modal-dialog modal-dialog-centered" role="document">
                <div className="modal-content">
                  <div className="modalBorder d-flex justify-content-end align-items-center p-2">
                    <CloseSharpIcon
                      className="material-symbols-sharp me-2 pointer"
                      onClick={() => {
                        handleCloseManageResume();
                      }}
                    />
                  </div>
                  <div className="p-2 pt-2 text-center reumeModal">
                    <CheckSharpIcon />
                    <p>{t("User Profile.Resume details added successfully!")}</p>
                  </div>
                  <div className="row modal-p settings CreateCompany">
                    <div className="text-center mt-4 mb-3">
                      <button
                        type="button"
                        className="mainBtn1"
                        onClick={redirectResume}
                        style={{ width: "100px" }}
                      >
                        {t("Sidemenubar.Manage")}
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </Portal>
        </>
      )}

      <SuccessToast
        show={showToast}
        message={toastMessage}
        onClose={() => setShowToast(false)}
      />

      <WarningToast
        show={showWarningToast}
        message={warningToastMessage}
        onClose={() => setShowWarningToast(false)}
      />

      <ErrorToast
        show={showErrorToast}
        message={ErrorToastMessage}
        onClose={() => setShowErrorToast(false)}
      />

      {unauthorisedModal && (
        <Portal layer="modal">
          <div
            className="modal fade show postAdd wlj-overlay-modal"
            tabIndex="-1"
            role="dialog"
            style={{ display: "flex" }}
          >
            <div className="modal-dialog modal-dialog-centered" role="document">
              <div className="modal-content d-flex justify-content-around p-2">
                <div className="d-flex justify-content-between align-items-center p-2">
                  <div>
                    <h4 className="text-center AdBlocker">{t("Recommendations.Warning")}</h4>
                    <p className="text-center ad-p">
                      {t("modals.Your session has expired or you are not authorized to access this resource. Please log in again to continue")}
                    </p>
                    <div className="text-center m-auto mt-3">
                      <button
                        type="button"
                        className="mainBtn1 "
                        onClick={() => {
                          setUnauthorisedModal(!unauthorisedModal)
                          navigate("/SignIn");
                          localStorage.clear();
                          sessionStorage.removeItem('hasModalShown');
                        }}
                      >
                        {t("modals.login")}
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Portal>
      )}
    </>
  );
};

export default UpdateProfile;
